module.exports = __webpack_public_path__ + "img/Cover_HW_17.09c0de50.jpg";